
<div
    class  = "order-column"
    :class = "unit.header || unit.lastInGroup ? 'unit-header-divider' : ''"
>
    <div v-if="unit.header" class="primary--text">
        {{ unit.order.customer }}
    </div>
    <div  v-if="unit.header" class="secondary--text" style="font-size: 12px;margin-top: -2px;">
        {{ orders }}
    </div>
</div>
